/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyDocumentApprovalListItemViewModelPaginatedResponse } from "../types/AssociatedCompanyDocumentApprovalListItemViewModelPaginatedResponse.ts";
import { associatedCompanyDocumentApprovalListItemViewModelSchema } from "./associatedCompanyDocumentApprovalListItemViewModelSchema.ts";

export const associatedCompanyDocumentApprovalListItemViewModelPaginatedResponseSchema =
  z.object({
    data: z
      .array(
        z.lazy(() => associatedCompanyDocumentApprovalListItemViewModelSchema),
      )
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<AssociatedCompanyDocumentApprovalListItemViewModelPaginatedResponse>;
